/* ============================================================
   VENESSO — Scarsilk  ·  custom interactions (vanilla JS)
   One init function per component. Each bails early if its
   element is absent, so this single file is safe on every page.
   ============================================================ */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveal on scroll ---------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll(".vn-reveal");
    if (!els.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
    );
    els.forEach(function (el) { io.observe(el); });

    // Safety net: reveal anything at or above the fold even if the
    // observer misses it (fast programmatic scrolls, restored scroll pos).
    var sweep = function () {
      var vh = window.innerHeight || 800;
      els.forEach(function (el) {
        if (el.classList.contains("is-in")) return;
        if (el.getBoundingClientRect().top < vh * 0.9) {
          el.classList.add("is-in");
          io.unobserve(el);
        }
      });
    };
    sweep();
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sweep(); ticking = false; });
    }, { passive: true });
    window.addEventListener("resize", sweep, { passive: true });
    window.addEventListener("load", sweep);
  }

  /* ---- Hero ready (image settle) ------------------------- */
  function initHero() {
    var hero = document.querySelector(".vn-hero");
    if (!hero) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add("is-ready"); });
    });
  }

  /* ---- Marquee: duplicate track for seamless loop -------- */
  function initMarquee() {
    document.querySelectorAll(".vn-marquee__track").forEach(function (track) {
      if (track.dataset.vnCloned) return;
      track.dataset.vnCloned = "1";
      track.innerHTML += track.innerHTML;
    });
  }

  /* ---- Before / after comparator ------------------------- */
  function initCompare() {
    document.querySelectorAll(".vn-compare").forEach(function (root) {
      var beforeWrap = root.querySelector(".vn-compare__before-wrap");
      var handle = root.querySelector(".vn-compare__handle");
      if (!beforeWrap || !handle) return;
      var beforeImg = beforeWrap.querySelector(".vn-compare__img");

      var dragging = false;

      function sizeBefore() {
        if (beforeImg) beforeImg.style.width = root.getBoundingClientRect().width + "px";
      }
      sizeBefore();
      window.addEventListener("resize", sizeBefore, { passive: true });
      if ("ResizeObserver" in window) { new ResizeObserver(sizeBefore).observe(root); }

      function setPos(clientX) {
        var rect = root.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(2, Math.min(98, pct));
        beforeWrap.style.width = pct + "%";
        handle.style.left = pct + "%";
      }

      function down(e) {
        dragging = true;
        root.classList.add("is-dragging");
        setPos((e.touches ? e.touches[0] : e).clientX);
        e.preventDefault();
      }
      function move(e) {
        if (!dragging) return;
        setPos((e.touches ? e.touches[0] : e).clientX);
      }
      function up() {
        dragging = false;
        root.classList.remove("is-dragging");
      }

      handle.addEventListener("mousedown", down);
      root.addEventListener("mousedown", down);
      window.addEventListener("mousemove", move);
      window.addEventListener("mouseup", up);
      handle.addEventListener("touchstart", down, { passive: false });
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("touchend", up);

      // Keyboard access
      handle.setAttribute("tabindex", "0");
      handle.setAttribute("role", "slider");
      handle.setAttribute("aria-label", "Reveal before and after");
      handle.addEventListener("keydown", function (e) {
        var cur = parseFloat(beforeWrap.style.width) || 50;
        if (e.key === "ArrowLeft") { beforeWrap.style.width = handle.style.left = Math.max(2, cur - 4) + "%"; }
        if (e.key === "ArrowRight") { beforeWrap.style.width = handle.style.left = Math.min(98, cur + 4) + "%"; }
      });

      // Gentle auto-hint once in view
      if (!reduceMotion && "IntersectionObserver" in window) {
        var hinted = false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !hinted) {
              hinted = true;
              var seq = [50, 62, 38, 50];
              seq.forEach(function (v, i) {
                setTimeout(function () {
                  beforeWrap.style.transition = "width .6s cubic-bezier(.22,1,.36,1)";
                  handle.style.transition = "left .6s cubic-bezier(.22,1,.36,1)";
                  beforeWrap.style.width = v + "%";
                  handle.style.left = v + "%";
                  if (i === seq.length - 1) {
                    setTimeout(function () {
                      beforeWrap.style.transition = "";
                      handle.style.transition = "";
                    }, 650);
                  }
                }, 400 + i * 620);
              });
              io.disconnect();
            }
          });
        }, { threshold: 0.5 });
        io.observe(root);
      }
    });
  }

  /* ---- FAQ accordion ------------------------------------- */
  function initFaq() {
    document.querySelectorAll(".vn-acc").forEach(function (acc) {
      var q = acc.querySelector(".vn-acc__q");
      var a = acc.querySelector(".vn-acc__a");
      if (!q || !a) return;
      var inner = a.querySelector(".vn-acc__a-inner");
      q.setAttribute("aria-expanded", "false");
      q.addEventListener("click", function () {
        var open = acc.classList.toggle("is-open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
        a.style.height = open ? inner.offsetHeight + "px" : "0px";
      });
    });
    window.addEventListener("resize", function () {
      document.querySelectorAll(".vn-acc.is-open .vn-acc__a").forEach(function (a) {
        var inner = a.querySelector(".vn-acc__a-inner");
        if (inner) a.style.height = inner.offsetHeight + "px";
      });
    });
  }

  /* ---- Count-up numbers --------------------------------- */
  function initCountUp() {
    var nums = document.querySelectorAll("[data-vn-count]");
    if (!nums.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.dataset.vnCount; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var target = parseFloat(el.dataset.vnCount);
        var suffix = el.dataset.vnSuffix || "";
        var dur = 1400, start = performance.now();
        function tick(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (target % 1 ? val.toFixed(1) : Math.round(val)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Product gallery + variants ----------------------- */
  function initProduct() {
    var root = document.querySelector("[data-vn-product]");
    if (!root) return;

    // Gallery
    var stage = root.querySelector(".vn-pdp__stage img");
    root.querySelectorAll(".vn-pdp__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.dataset.full;
        if (stage && full) stage.src = full;
        root.querySelectorAll(".vn-pdp__thumb").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });

    // Variants
    var dataEl = root.querySelector("[data-vn-variants]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || variants.length < 2) return;

    var idInput = root.querySelector("[data-vn-variant-id]");
    var priceEl = root.querySelector("[data-vn-price]");
    var compareEl = root.querySelector("[data-vn-compare-price]");
    var atc = root.querySelector(".vn-pdp__atc");
    var selected = {};

    root.querySelectorAll(".vn-pdp__swatch").forEach(function (sw) {
      sw.addEventListener("click", function () {
        var opt = sw.dataset.option, val = sw.dataset.value;
        selected[opt] = val;
        root.querySelectorAll('.vn-pdp__swatch[data-option="' + CSS.escape(opt) + '"]').forEach(function (s) {
          s.classList.toggle("is-active", s === sw);
        });
        resolve();
      });
    });

    function resolve() {
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) {
          var name = dataEl.dataset.optionNames.split("|")[i];
          return selected[name] === undefined || selected[name] === o;
        });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (compareEl) compareEl.style.display = match.compare_at && match.compare_at !== match.price ? "" : "none";
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.dataset.labelAvailable : atc.dataset.labelSoldout;
      }
    }
  }

  /* ---- Subtle pointer tilt on cards --------------------- */
  function initTilt() {
    if (reduceMotion || window.matchMedia("(pointer: coarse)").matches) return;
    document.querySelectorAll("[data-vn-tilt]").forEach(function (card) {
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = "perspective(900px) rotateY(" + x * 4 + "deg) rotateX(" + -y * 4 + "deg) translateY(-6px)";
      });
      card.addEventListener("mouseleave", function () { card.style.transform = ""; });
    });
  }

  // Absolute fail-safe: never leave content invisible.
  setTimeout(function () {
    document.querySelectorAll(".vn-reveal:not(.is-in)").forEach(function (el) {
      el.classList.add("is-in");
    });
  }, 2200);

  function boot() {
    if (window.__vnBooted) return;
    window.__vnBooted = true;
    initReveal();
    initHero();
    initMarquee();
    initCompare();
    initFaq();
    initCountUp();
    initProduct();
    initTilt();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
